<template>
  <div>
    <add-form />
  </div>
</template>
<script>

import AddForm from "../add/index.vue";
export default {
  components: { AddForm },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
</style>